// extracted by mini-css-extract-plugin
module.exports =  {"close-btn":"_93444fe79c--close-btn--eTV5h"};